import z from 'zod';

export const TestAccuracyQuestionsQuerySchema = z.object({
  startDate: z.string(),
  endDate: z.string(),
});

export type TTestAccuracyQuestionsQuery = z.infer<
  typeof TestAccuracyQuestionsQuerySchema
>;

export const TestAccuracyQuestionSchema = z.object({
  _id: z.string(),
  question: z.string(),
  originalAnswer: z.string(),
  improvedAnswer: z.string(),
  newAnswer: z.string().optional(),
  createdAt: z.string(),
});

export type TTestAccuracyQuestion = z.infer<typeof TestAccuracyQuestionSchema>;

export const TestAccuracyQuestionsResponseSchema =
  TestAccuracyQuestionSchema.array();

export const StartTestAccuracyTestBodySchema = z.object({
  questions: z.array(TestAccuracyQuestionSchema.omit({ newAnswer: true })),
  llmBlock: z.any(),
});

export type TStartTestAccuracyTestBody = z.infer<
  typeof StartTestAccuracyTestBodySchema
>;

export const StartTestAccuracyTestResponseSchema =
  TestAccuracyQuestionSchema.array();

export type TStartTestAccuracyTestResponse = z.infer<
  typeof StartTestAccuracyTestResponseSchema
>;

export const TestAccuracyReviewDataSchema = z.object({
  questionId: z.string(),
  question: z.string(),
  originalAnswer: z.string(),
  improvedAnswer: z.string(),
  newAnswer: z.string(),
  isCorrect: z.boolean(),
});

export const SaveTestAccuracyResultSchema = z.object({
  accuracy: z.number().min(0).max(100).default(0),
  startDate: z.string(),
  endDate: z.string(),
  reviewData: z.array(TestAccuracyReviewDataSchema),
});

export type TSaveTestAccuracyResult = z.infer<
  typeof SaveTestAccuracyResultSchema
>;

export type TTestAccuracyReviewData = z.infer<
  typeof TestAccuracyReviewDataSchema
>;

export const TestAccuracyResultSchema = z.object({
  _id: z.string(),
  startDate: z.string(),
  endDate: z.string(),
  accuracy: z.number().min(0).max(100).default(0),
  reviewData: z.array(TestAccuracyReviewDataSchema),
});

export const TestAccuracyResultsResponseSchema =
  TestAccuracyResultSchema.array();

export type TTestAccuracyResult = z.infer<typeof TestAccuracyResultSchema>;
